import { CSSProperties, useEffect, useRef } from 'react';
import { Outlet } from 'react-router';
import { LoadIndicatorCenteredView } from '@vivli/shared/views';
import { useDataRequestContext } from '@vivli/features/data-requests/infrastructure/context';
import { useActiveUserContext } from '@vivli/core/infrastructure/context';
import { useModalApiContext } from '@vivli/core/infrastructure/context';
import { DataRequestStatusEnum } from '@vivli/features/data-requests/infrastructure/enum';
import { useDataRequestRoutes } from '@vivli/features/data-requests/infrastructure/hook';

const routesContainerStyle: CSSProperties = {
    marginTop: 20,
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    flexGrow: 1,
    paddingRight: '5px',
    position: 'relative',
    flexDirection: 'column'
};

export const DataRequestRoutesComponent = () => {
    const { dataRequest } = useDataRequestContext();
    const { user: activeUser } = useActiveUserContext();
    const modalService = useModalApiContext();
    const messageShownRef = useRef(false);
    const { isFromEmailLink } = useDataRequestRoutes(dataRequest.id);

    useEffect(() => {
        if (!dataRequest || !activeUser || messageShownRef.current) {
            return;
        }

        if (dataRequest.userId === activeUser.userId && dataRequest.status === DataRequestStatusEnum.Draft && !isFromEmailLink) {
            modalService.message(
                'You are viewing your own draft data request as an administrator.  To edit this request, view your request through the link on the site header.'
            );
            messageShownRef.current = true;
        }
    }, [dataRequest, activeUser]);

    if (!dataRequest) {
        return <LoadIndicatorCenteredView />;
    }

    return (
        <div style={routesContainerStyle} className="scrolly">
            <Outlet />
        </div>
    );
};
